import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { SidenavFooterItem, SidenavHeader, SidenavMenu } from '../sidenav/interfaces';
// import { DEFAULT_CONFIG_BASE_URL } from './base-urls';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { delay, map } from 'rxjs/operators';

export const SidenavConfigService = new InjectionToken<SidenavModuleConfig>('sidenav-module.config');

export interface SidenavModuleConfig {
  stage?: string;
  /*to send custom parameters */
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class SidenavConfig {
  private moduleConfig?: SidenavModuleConfig;

  // private defaultConfigBaseUrl = '';
  public defaultConfig;

  public isSideNavInitialized: Subject<boolean> = new Subject<boolean>();

  private DEFAULT_STAGE = 'development';

  private defaultSidenavHeaderConfig = <SidenavHeader>{
    displayName: true,
    avatarImageUrl: null
  };

  private defaultSidenavMenuConfig: SidenavMenu[] = [];
  private defaultSidenavFooterConfig;

  private defaultSidenavHelpItem: SidenavFooterItem;

  constructor(
    // private http: HttpClient,
    @Inject('environment') @Optional() private environment: string,
    @Optional() @Inject(SidenavConfigService) config?: SidenavModuleConfig
  ) {
    if (!this.environment) {
      this.environment = 'development';
    }
    this.set(config);

    // this.defaultConfigBaseUrl = DEFAULT_CONFIG_BASE_URL[this.environment];

    this.getDefaultConfig().subscribe(config => {
      this.defaultConfig = config;
      this.defaultSidenavMenuConfig = config?.menu?.items || [];
      this.defaultSidenavFooterConfig = config?.footer;
      this.defaultSidenavHelpItem = config?.footer?.help;
      this.isSideNavInitialized.next(true);
    });
  }

  private getDefaultConfig(): Observable<any> {
    // no need to load default config from bucket
    // let now = new Date();
    // return this.http.get(this.defaultConfigBaseUrl + '?t=' + now.toISOString()).pipe(
    //   map((config: any) => {
    //     return config;
    //   })
    // );
    // subscription on isSideNavInitialized in SidenavComponent.initSideNav is not triggered without delay
    return of({}).pipe(delay(1));
  }

  set(config: SidenavModuleConfig): void {
    this.moduleConfig = config ? config : this.moduleConfig;
  }

  get(): SidenavModuleConfig {
    return this.moduleConfig as SidenavModuleConfig;
  }

  getHeaderConfig(): SidenavHeader {
    return this.defaultSidenavHeaderConfig;
  }

  getMenuConfig() {
    return this.defaultSidenavMenuConfig;
  }

  getFooterConfig() {
    return this.defaultSidenavFooterConfig;
  }

  getDefaultHelpItemItem() {
    return this.defaultSidenavHelpItem;
  }
}
